import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import Lottie from 'lottie-react';
import animationData from 'animations/mobileLoader.json';
import styles from './styles.pcss';
const MobileAppLoader = ()=>{
    useStyles(styles);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.MobileAppLoader,
        children: /*#__PURE__*/ _jsx(Lottie, {
            animationData: animationData,
            loop: true
        })
    });
};
export default MobileAppLoader;
